var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    { ref: "multi-select", attrs: { name: _vm.name, multiple: "multiple" } },
    _vm._l(_vm.options, function(option, index) {
      return _c(
        "option",
        {
          domProps: {
            value: option.value,
            selected: _vm.optionSelected(option.value)
          }
        },
        [_vm._v(_vm._s(option.label))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }